<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/pages/Dashboard.scss";

  .unit{
    color: #00c3c3;
    font-size: 10px;
  }

  th{
    background-color: #ededed;
  }

  .date, .alias{
    width: 120px!important;
  }

  .general{
    width: 75px!important;
  }

  .vs-table--tbody-table{
    width: auto!important;
    min-width: 10px!important;
  }
  .vs-con-tbody, .header-table{
    width: fit-content!important;
  }
</style>
<template>
  <div>
    <div class="container-cards">
      <div class="p-1 alerts  container-table" v-if="data['Alerts'].length > 0">
        <vx-card class="h-full text-left">
          <div class="font-bold text-lg mb-4">{{$t('Labels.AlertDevices')}}</div>
          <div v-bind:key="indextr" v-for="(item, indextr) in data['Alerts']" class="inline-block px-3 cursor-pointer" @click="goToDetail(routes[item.device]+item.uuid)">
            <div class="text-center">
              <iconEnergy v-if="item.device === 'E'" :width="25" :height="25" iconColor="#EA5455"/>
              <iconAgro v-if="item.device === 'A'" :width="25" :height="25" iconColor="#EA5455"/>
              <iconDoor v-if="item.device === 'P'" :width="25" :height="25" iconColor="#EA5455"/>
              <iconAirflow v-if="item.device === 'F'" :width="25" :height="25" iconColor="#EA5455"/>
              <iconEnv v-if="item.device === 'T'" :width="25" :height="25" iconColor="#EA5455"/>
            </div>
            <div class="text-center">{{item.alias}}</div>
          </div>
        </vx-card>
      </div>
      <div class="p-1 energy  container-table" v-if="data['E'].length > 0">
        <vx-card class="h-full">
          <vs-table  :data="data['E']" @selected="goToDetail">
            <template slot="header">
              <div class="font-bold text-lg mb-4">{{$tc('Labels.Energy',1)}}</div>
            </template>
            <template slot="thead">
              <vs-th class="alias">
                {{$t('Labels.Alias')}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Energy')}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.ElectricCurrent', 2, { n: 'A' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.ElectricCurrent', 2, { n: 'B' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.ElectricCurrent', 2, { n: 'C' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Voltage', 2, { n: 'A' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Voltage', 2, { n: 'B' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Voltage', 2, { n: 'C' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Power', 2, { n: 'A' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Power', 2, { n: 'B' })}}
              </vs-th>
              <vs-th class="general">
                {{$tc('Labels.Power', 2, { n: 'C' })}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr  :data="`/energy/detail/${item.uuid}`"  :key="indextr" v-for="(item, indextr) in data">
                <vs-td>
                  <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" :style="bgStates[item.status]">
                    <iconEnergy :width="18" :height="18" :iconColor="colorStates[item.status]"/>
                  </div>
                  <div class="inline-block font-bold align-middle ml-2">{{item.alias}}</div>
                </vs-td>
                <vs-td>
                  <iconEnergy type="A" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_energia]"/>
                  <span>{{parseFloat(item.value[0].energia).toFixed(2)}}</span>
                  <span class="unit">A</span>
                </vs-td>
                <vs-td>
                  <iconCurrent type="A" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_corriente_a]"/>
                  <span>{{parseFloat(item.value[0].corriente_a).toFixed(2)}}</span>
                  <span class="unit">A</span>
                </vs-td>
                <vs-td>
                  <iconCurrent type="B" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_corriente_b]"/>
                  <span>{{parseFloat(item.value[0].corriente_b).toFixed(2)}}</span>
                  <span class="unit">A</span>
                </vs-td>
                <vs-td>
                  <iconCurrent type="C" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_corriente_c]"/>
                  <span>{{parseFloat(item.value[0].corriente_c).toFixed(2)}}</span>
                  <span class="unit">A</span>
                </vs-td>
                <vs-td>
                  <iconVoltage type="A" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_voltaje_a]"/>
                  <span>{{parseFloat(item.value[0].voltaje_a).toFixed(2)}}</span>
                  <span class="unit">V</span>
                </vs-td>
                <vs-td>
                  <iconVoltage type="B" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_voltaje_b]"/>
                  <span>{{parseFloat(item.value[0].voltaje_b).toFixed(2)}}</span>
                  <span class="unit">V</span>
                </vs-td>
                <vs-td>
                  <iconVoltage type="C" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_voltaje_c]"/>
                  <span>{{parseFloat(item.value[0].voltaje_c).toFixed(2)}}</span>
                  <span class="unit">V</span>
                </vs-td>
                <vs-td>
                  <iconPower type="A" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_potencia_a]"/>
                  <span>{{parseFloat(item.value[0].potencia_a).toFixed(2)}}</span>
                  <span class="unit">W</span>
                </vs-td>
                <vs-td>
                  <iconPower type="B" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_potencia_b]"/>
                  <span>{{parseFloat(item.value[0].potencia_b).toFixed(2)}}</span>
                  <span class="unit">W</span>
                </vs-td>
                <vs-td>
                  <iconPower type="C" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_potencia_c]"/>
                  <span>{{parseFloat(item.value[0].potencia_c).toFixed(2)}}</span>
                  <span class="unit">W</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="p-1 container-table" :class="clases['A'] ? 'agro':''" v-if="data['A'].length > 0">
        <vx-card class="h-full">
          <vs-table  :data="data['A']" @selected="goToDetail">
            <template slot="header">
              <div class="font-bold text-lg mb-4">{{$t('Labels.Agro')}}</div>
            </template>
            <template slot="thead">
              <vs-th class="alias">
                {{$t('Labels.Alias')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.GroundTemperature')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.HumidityGround')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.EnvTemperature')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Humidity')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Precipitation')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Light')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="`/agro/detail/${item.uuid}`" :key="indextr" v-for="(item, indextr) in data" >
                <vs-td>
                  <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" :style="bgStates[item.status]">
                    <iconAgro iconName="" :width="18" :height="18" :iconColor="colorStates[item.status]"/>
                  </div>
                  <div class="inline-block font-bold align-middle ml-2">{{item.alias}}</div>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_temp]"><iconTemperature/></iconBase>
                  <span>{{parseFloat(item.value[0].temp).toFixed(2)}}°</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_ground_hum]"><iconTemperature/></iconBase>
                  <span>{{parseFloat(item.value[0].ground_hum).toFixed(2)}}</span>
                  <span class="unit">%</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :stroke="colorStates[item.value[0].status_atemp]"><iconPressure/></iconBase>
                  <span>{{parseFloat(item.value[0].atemp).toFixed(2)}}°</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_ahum]"><iconHumidity/></iconBase>
                  <span>{{parseFloat(item.value[0].ahum).toFixed(2)}}</span>
                  <span class="unit">%</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_rain_level]"><iconPrecipitation/></iconBase>
                  <span>{{parseFloat(item.value[0].rain_level).toFixed(2)}}</span>
                  <span class="unit">%</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_light_level]"><iconLight/></iconBase>
                  <span>{{parseFloat(item.value[0].light_level).toFixed(2)}}</span>
                  <span class="unit">%</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="p-1 container-table" :class="clases['F'] ? 'airflow':''" v-if="data['F'].length > 0">
        <vx-card class="h-full">
          <vs-table  :data="data['F']" @selected="goToDetail">
            <template slot="header">
              <div class="font-bold text-lg mb-4">{{$t('Labels.AirFlow')}}</div>
            </template>
            <template slot="thead">
              <vs-th class="alias">
                {{$t('Labels.Alias')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Flow')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Temperature')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Temperature')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Pressure')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Size')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="`/airflow/detail/${item.uuid}`" :key="indextr" v-for="(item, indextr) in data" >
                <vs-td>
                  <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" :style="bgStates[item.status]">
                    <iconAirflow iconName="" :width="18" :height="18" :iconColor="colorStates[item.status]"/>
                  </div>
                  <div class="inline-block font-bold align-middle ml-2">{{item.alias}}</div>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :stroke="colorStates[item.value[0].status_flow]"><iconFlow/></iconBase>
                  <span>{{parseFloat(item.value[0].flow).toFixed(2)}}</span>
                  <span class="unit">ft3/h</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_temperature]"><iconTemperature/></iconBase>
                  <span>{{parseFloat(item.value[0].temperature).toFixed(2)}}</span>
                  <span class="unit">°C</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_temperature]"><iconTemperature/></iconBase>
                  <span>{{((parseFloat(item.value[0].temperature || 0 ) * 9 / 5) + 32).toFixed(2)}}</span>
                  <span class="unit">°F</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :stroke="colorStates[item.value[0].status_pressure]"><iconPressure/></iconBase>
                  <span>{{parseFloat(item.value[0].pressure).toFixed(2)}}</span>
                  <span class="unit">Psi</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" stroke="#14A5FF"><iconSize/></iconBase>
                  <span class="ml-1">{{item.value[0].size}}</span>
                  <span class="unit">in</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="p-1 container-table" :class="clases['P'] ? 'door':''" v-if="data['P'].length > 0">
        <vx-card class="h-full">
          <vs-table  :data="data['P']" @selected="goToDetail">
            <template slot="header">
              <div class="font-bold text-lg mb-4">{{$t('Labels.DoorsSensor')}}</div>
            </template>
            <template slot="thead">
              <vs-th class="alias">
                {{$t('Labels.Alias')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Status')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="`/doors/detail/${item.uuid}`" :key="indextr" v-for="(item, indextr) in data" >
                <vs-td>
                  <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" :style="bgDoorState[item.status]">
                    <iconDoor iconName="" :width="18" :height="18" :iconColor="colorsDoorState[item.status]"/>
                  </div>
                  <div class="inline-block font-bold align-middle ml-2">{{item.alias}}</div>
                </vs-td>
                <vs-td>
                  {{doorLabels[item.status]}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div class="p-1 container-table" :class="clases['T']? 'env':''" v-if="data['T'].length > 0">
        <vx-card class="h-full">
          <vs-table  :data="data['T']" @selected="goToDetail">
            <template slot="header">
              <div class="font-bold text-lg mb-4">{{$t('Labels.EnvTemperature')}}</div>
            </template>
            <template slot="thead">
              <vs-th class="alias">
                {{$t('Labels.Alias')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Temperature')}}
              </vs-th>
              <vs-th class="general">
                {{$t('Labels.Humidity')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="`/env/detail/${item.uuid}`" :key="indextr" v-for="(item, indextr) in data" >
                <vs-td>
                  <div class="inline-block p-1 align-middle h-8 w-8 rounded-sm" :style="bgStates[item.status]">
                    <iconEnv iconName="" :width="18" :height="18" :iconColor="colorStates[item.status]"/>
                  </div>
                  <div class="inline-block font-bold align-middle ml-2">{{item.alias}}</div>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_temperature]"><iconTemperature/></iconBase>
                  <span>{{parseFloat(item.value[0].temperature).toFixed(2)}}°</span>
                </vs-td>
                <vs-td>
                  <iconBase iconName="" :width="18" :height="18" :iconColor="colorStates[item.value[0].status_humidity]"><iconHumidity/></iconBase>
                  <span>{{parseFloat(item.value[0].humidity).toFixed(2)}}</span>
                  <span class="unit">%</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request.js'
import iconBase from '@/components/icons/iconBase'
import iconEnergy from '@/components/icons/iconEnergy'
import iconCurrent from '@/components/icons/iconCurrent'
import iconVoltage from '@/components/icons/iconVoltage'
import iconPower from '@/components/icons/iconPower'
import iconTemperature from '@/components/icons/iconTemperature'
import iconPressure from '@/components/icons/iconPressure'
import iconHumidity from '@/components/icons/iconHumidity'
import iconPrecipitation from '@/components/icons/iconPrecipitation'
import iconLight from '@/components/icons/iconLight'
import iconFlow from '@/components/icons/iconFlow'
import iconAgro from '@/components/icons/iconAgro'
import iconAirflow from '@/components/icons/iconAirflow'
import iconDoor from '@/components/icons/iconDoor'
import iconEnv from '@/components/icons/iconEnv'
import iconSize from '@/components/icons/iconSize'

export default {
  name: 'dashboard',
  components: {
    iconBase,
    iconEnergy,
    iconCurrent,
    iconVoltage,
    iconPower,
    iconTemperature,
    iconPressure,
    iconHumidity,
    iconPrecipitation,
    iconLight,
    iconFlow,
    iconAgro,
    iconAirflow,
    iconDoor,
    iconEnv,
    iconSize
  },
  data () {
    return {
      data: {
        E: [],
        A: [],
        F: [],
        P: [],
        T: [],
        Alerts: []
      },
      clases: {
        E: false,
        A: false,
        F: false,
        P: false,
        T: false
      },
      colorsDoorState: [
        '#14A5FF',
        '#FF9F43',
        '#EA5455'
      ],
      bgDoorState: [
        'background-color:rgb(20 165 255 / 25%)',
        'background-color:rgb(255 159 67 / 25%)',
        'background-color:rgb(234 84 85 / 25%)'
      ],
      colorStates: [
        '#14A5FF',
        '#EA5455'
      ],
      bgStates: [
        'background-color:rgb(20 165 255 / 25%)',
        'background-color:rgb(234 84 85 / 25%)'
      ],
      routes: {
        E: '/energy/detail/',
        A: '/agro/detail/',
        F: '/airflow/detail/',
        P: '/doors/detail/',
        T: '/env/detail/'
      },
      doorLabels: [
        this.$t('Labels.Close'),
        this.$t('Labels.Open'),
        this.$t('Labels.LongOpen')
      ]
    }
  },
  methods: {
    async getResponse () {
      const params = {
        url: 'modelo/general',
        method: 'GET'
      }

      await request(params).then(response => {
        response.data.data.forEach(element => {
          if (element.value.length > 0) element.value = JSON.parse(element.value)
          this.data[element.device].push(element)
          if (element.status === '1') { this.data.Alerts.push(element) }
        })
        this.setClases()
      })
    },
    setClases () {
      if (this.showCard('F') && this.showCard('T')) {
        this.clases.F = true
        this.clases.T = true
      }

      if (this.showCard('A') && this.showCard('P')) {
        this.clases.A = true
        this.clases.P = true
      }
    },
    showCard (type) {
      return this.data[type].length > 0
    },
    goToDetail (route) {
      this.$router.push({ path: route })
    },
    updateAlerts (device) {
      if (parseInt(device.status) !== 0) {
        const found = this.data.Alerts.filter(element => element.uuid === device.uuid)[0]
        if (found === undefined) {
          this.data.Alerts.push(device)
        }
      } else {
        this.data.Alerts = this.data.Alerts.filter(element => element.uuid !== device.uuid)
      }
    }
  },
  sockets: {
    agro (payload) {
      this.data.A.forEach(toModify => {
        if (toModify.uuid === payload.uuid) {
          toModify.value[0].ahum = payload.ahum
          toModify.value[0].temp = payload.temp
          toModify.value[0].atemp = payload.atemp
          toModify.value[0].ground_hum = payload.ground_hum
          toModify.value[0].rain_level = payload.rain_level
          toModify.value[0].light_level = payload.light_level
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
          this.updateAlerts(toModify)
        }
      })
    },
    airflow (payload) {
      this.data.F.forEach(toModify => {
        if (toModify.uuid === payload.uuid) {
          toModify.value[0].pressure = payload.pressure
          toModify.value[0].flow = payload.flow
          toModify.value[0].temperature = payload.temperature
          toModify.value[0].status_flow = payload.status_flow
          toModify.value[0].status_pressure = payload.status_pressure
          toModify.value[0].status_temperature = payload.status_temperature
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
          this.updateAlerts(toModify)
        }
      })
    },
    door (payload) {
      this.data.P.forEach(toModify => {
        if (toModify.uuid === payload.uuid) {
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
          this.updateAlerts(toModify)
        }
      })
    },
    energie (payload) {
      this.data.E.forEach(toModify => {
        if (toModify.uuid === payload.uuid) {
          toModify.value[0].corriente_a = payload.corriente_a
          toModify.value[0].corriente_b = payload.corriente_b
          toModify.value[0].corriente_c = payload.corriente_c
          toModify.value[0].energia = payload.energia
          toModify.value[0].potencia_a = payload.potencia_a
          toModify.value[0].potencia_b = payload.potencia_b
          toModify.value[0].potencia_c = payload.potencia_c
          toModify.value[0].voltaje_a = payload.voltaje_a
          toModify.value[0].voltaje_b = payload.voltaje_b
          toModify.value[0].voltaje_c = payload.voltaje_c
          toModify.value[0].status_corriente_a = payload.status_corriente_a
          toModify.value[0].status_corriente_b = payload.status_corriente_b
          toModify.value[0].status_corriente_c = payload.status_corriente_c
          toModify.value[0].status_factor_a = payload.status_factor_a
          toModify.value[0].status_factor_b = payload.status_factor_b
          toModify.value[0].status_factor_c = payload.status_factor_c
          toModify.value[0].status_potencia_a = payload.status_potencia_a
          toModify.value[0].status_potencia_b = payload.status_potencia_b
          toModify.value[0].status_potencia_c = payload.status_potencia_c
          toModify.value[0].status_potencia_r_a = payload.status_potencia_r_a
          toModify.value[0].status_potencia_r_b = payload.status_potencia_r_b
          toModify.value[0].status_potencia_r_c = payload.status_potencia_r_c
          toModify.value[0].status_voltaje_a = payload.status_voltaje_a
          toModify.value[0].status_voltaje_b = payload.status_voltaje_b
          toModify.value[0].status_voltaje_c = payload.status_voltaje_c
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
          this.updateAlerts(toModify)
        }
      })
    },
    tempHum (payload) {
      this.data.T.forEach(toModify => {
        if (toModify.uuid === payload.uuid) {
          toModify.value[0].humidity = payload.humidity
          toModify.value[0].temperature = payload.temperature
          toModify.value[0].status_humidity = payload.status_humidity
          toModify.value[0].status_temperature = payload.status_temperature
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
          this.updateAlerts(toModify)
        }
      })
    }
  },
  mounted () {
    this.getResponse()
  }
}
</script>
